// src/app/core/services/account.service.ts

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env';

// GET /api/Account/GetProfile response (full, kept for backwards compat)
export interface UserProfile {
  userId: number;
  username: string;
  emri: string;
  numripersonal: string;
  email: string;
  filialla: string;
  filialla_id: number;
  teDrejtatNeLLojeTeSigurimeve: InsuranceTypePermission[];
  workPlaceId: number | null;
  workPlaceName: string;
  portalPermissions: string[];
}

// GET /api/Account/GetIdentity response (lightweight, no permissions)
export interface UserIdentity {
  userId: number;
  username: string;
  emri: string;
  numripersonal: string;
  email: string;
  filialla: string;
  filialla_id: number;
  workPlaceId: number | null;
  workPlaceName: string;
}

// GET /api/Account/GetPermissions response
export interface UserPermissions {
  userId: number;
  teDrejtatNeLLojeTeSigurimeve: InsuranceTypePermission[];
  portalPermissions: string[];
}

export interface InsuranceTypePermission {
  llojisig_id: number;
  llojisig: string;
}

// POST /api/Account/ChangePassword
export interface ChangePasswordRequest {
  NewPassword: string;
  ActualPassword: string;
}

export interface ChangePasswordResponse {
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class AccountService {
  private readonly baseUrl = `${environment.apiUrl}/Account`;
  private http = inject(HttpClient);

  /**
   * GET /api/Account/GetProfile (full monolithic — kept for backwards compat)
   */
  getProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.baseUrl}/GetProfile`);
  }

  /**
   * GET /api/Account/GetIdentity (lightweight — identity only, no permissions)
   */
  getIdentity(): Observable<UserIdentity> {
    return this.http.get<UserIdentity>(`${this.baseUrl}/GetIdentity`);
  }

  /**
   * GET /api/Account/GetPermissions (permissions only)
   */
  getPermissions(): Observable<UserPermissions> {
    return this.http.get<UserPermissions>(`${this.baseUrl}/GetPermissions`);
  }

  /**
   * POST /api/Account/ChangePassword
   */
  changePassword(currentPassword: string, newPassword: string): Observable<ChangePasswordResponse> {
    const body: ChangePasswordRequest = {
      ActualPassword: currentPassword,
      NewPassword: newPassword
    };
    return this.http.post<ChangePasswordResponse>(`${this.baseUrl}/ChangePassword`, body);
  }
}